// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************
*  Spacing Tokens
******************************/
:root {
  --m-space-0: 0rem;
  --m-space-025: 0.125rem;
  --m-space-050: 0.25rem;
  --m-space-075: 0.375rem;
  --m-space-100: 0.5rem;
  --m-space-150: 0.75rem;
  --m-space-200: 1rem;
  --m-space-250: 1.25rem;
  --m-space-300: 1.5rem;
  --m-space-350: 2rem;
  --m-space-400: 2.5rem;
  --m-space-450: 3rem;
  --m-space-500: 4rem;
  --m-space-600: 5rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens/_spacing.scss"],"names":[],"mappings":"AAAA;;8BAAA;AAGA;EACI,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AACJ","sourcesContent":["/******************************\n*  Spacing Tokens\n******************************/\n:root {\n    --m-space-0: 0rem;\n    --m-space-025: 0.125rem;\n    --m-space-050: 0.25rem;\n    --m-space-075: 0.375rem;\n    --m-space-100: 0.5rem;\n    --m-space-150: 0.75rem;\n    --m-space-200: 1rem;\n    --m-space-250: 1.25rem;\n    --m-space-300: 1.5rem;\n    --m-space-350: 2rem;\n    --m-space-400: 2.5rem;\n    --m-space-450: 3rem;\n    --m-space-500: 4rem;\n    --m-space-600: 5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
